var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('LaunchQuestionnaire',{attrs:{"id":parseInt(this.$route.params.id),"learning-mode":_vm.isInLearningMode}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }